import { createSlice } from '@reduxjs/toolkit';

export const INITIAL_STATE = {
  user: null,
  isLoading: false,
  isInitialLoading: false,
  error: null,
  sessionVersion: 0,
};

const userSlice = createSlice({
  name: 'user',
  initialState: {
    ...INITIAL_STATE,
  },
  reducers: {
    signInRequest(state) {
      state.user = null;
      state.sessionVersion += 1;
      state.isLoading = true;
    },
    signInSuccess(state, action) {
      return {
        ...state,
        user: action.payload.user,
        sessionVersion: state.sessionVersion + 1,
        isLoading: false,
        error: null,
      };
    },
    meRequest(state) {
      state.user = null;
      state.sessionVersion += 1;
      state.isLoading = true;
    },
    meSuccess(state, action) {
      return {
        ...state,
        user: action.payload.user,
        sessionVersion: state.sessionVersion + 1,
        isLoading: false,
        error: null,
      };
    },
    initialLoadRequest(state) {
      state.user = null;
      state.sessionVersion += 1;
      state.isInitialLoading = true;
    },
    initialLoadUnauthenticated(state) {
      state.user = null;
      state.isInitialLoading = false;
    },
    initialLoadSuccess(state, action) {
      return {
        ...state,
        user: action.payload.user,
        sessionVersion: state.sessionVersion + 1,
        isLoading: false,
        isInitialLoading: false,
        error: null,
      };
    },
    error(state, action) {
      state.user = null;
      state.sessionVersion += 1;
      state.error = action?.payload?.message || 'Unkown Error';
      state.isLoading = false;
      state.isInitialLoading = false;
    },
    clearErrors(state) {
      state.error = null;
      state.isLoading = false;
      state.isInitialLoading = false;
    },
    logoutRequest(state) {
      state.user = null;
      state.sessionVersion += 1;
    },
    logoutSuccess(state) {
      return {
        ...INITIAL_STATE,
        sessionVersion: state.sessionVersion + 1,
      };
    },
  },
});

export const {
  signInRequest,
  signInSuccess,
  logoutRequest,
  logoutSuccess,
  error,
  meRequest,
  meSuccess,
  initialLoadRequest,
  initialLoadSuccess,
  initialLoadUnauthenticated,
  clearErrors,
} = userSlice.actions;

export default userSlice.reducer;
